export default __webpack_public_path__ + "static/media/user-guide.53e6a128.svg";